/**
 * 首页静态路由数据
 * */

export default {
  path: '/home',
  name: 'home',
  component: () => import('@/views/index/components/home/index.vue'),
  meta: {
    unrequireLogin: true
  }
}
